export const gaEventTrigger = async (pageTitle: string, action: string) => {
    gtag('event', 'coming soon', {
        'page_title': pageTitle || "Untitled Page",
        'action': action || "Untitled Action",
    });
}